import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Link from '@material-ui/core/Link';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

import preferencesAPI from '../../api/preferences';

import {
  getString,
  iPhoneFriendlyButtonLabel,
} from '../../helpers/stringHelpers.js';

const stringsComponent = 'termsDialog';

class TermsDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true,
      confirm: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleChange(event) {
    const newValue =
      event.target.name === 'confirm'
        ? event.target.checked
        : event.target.value;

    this.setState({
      [event.target.name]: newValue,
    });
  }

  handleConfirm() {
    const { acceptTerms } = this.props;

    this.setState({ open: false });

    acceptTerms();
  }

  handleLogout() {
    const { logoutAction } = this.props;

    this.setState({ open: false });

    logoutAction();
  }

  render() {
    const { classes } = this.props;
    const { open, confirm } = this.state;

    const confirmButtonLabel = iPhoneFriendlyButtonLabel(
      getString(stringsComponent, 'CONTINUE_LABEL'),
      !confirm
    );

    return (
      <div>
        <Dialog open={open}>
          <DialogTitle>
            <Typography variant='h3' className={classes.title}>
              {getString(stringsComponent, 'TITLE')}
            </Typography>
          </DialogTitle>
          <Divider />
          <br />
          <DialogContent>
            <Typography component='div' variant='body1'>
              {getString(stringsComponent, 'CONTENT')}
            </Typography>
            <br />
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    defaultChecked={confirm}
                    name='confirm'
                    onChange={this.handleChange}
                  />
                }
                label={
                  <span>
                    I agree to the{' '}
                    <a
                      className={classes.link}
                      href='/privacy-and-terms-of-use'
                      target='_blank'
                    >
                      MyKāingaOra Terms of use and privacy policy
                    </a>
                  </span>
                }
              />
            </div>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button variant='outlined' onClick={this.handleLogout}>
              {getString(stringsComponent, 'LOGOUT_LABEL')}
            </Button>

            <Button
              variant='outlined'
              color='primary'
              onClick={this.handleConfirm}
              disabled={!confirm}
            >
              {iPhoneFriendlyButtonLabel(
                getString(stringsComponent, 'CONTINUE_LABEL'),
                !confirm
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(TermsDialog);
